import styled from 'styled-components';
import { teamTranslations } from '../../locales/teamTranslations';

const TeamContainer = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  position: relative;
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
`;

const Header = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 80px;
`;

const Headline = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  color: white;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  width: 100%;
  padding: 0 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const MemberCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 20px;
  padding: 30px;
  transition: transform 0.3s ease;

`;

const NameSection = styled.div`
  margin-bottom: 20px;
`;

const EnglishName = styled.h3`
  font-size: 1.8rem;
  color: white;
  margin: 0 0 10px 0;
`;

const LocalizedName = styled.div`
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 5px;
`;

const Role = styled.div`
  font-size: 1.2rem;
  color:rgb(238, 238, 238);
  margin-bottom: 15px;
  font-weight: 500;
`;

const Position = styled.div`
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 10px;
`;

const Expertise = styled.div`
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.5;
`;

const LinkedInButton = styled.a`
  display: inline-block;
  color: white;
  border-radius: 8px;
  text-decoration: none;
  font-size: 0.9rem;
  margin-top: 15px;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }
`;

function TeamTab({ currentLang }) {
  const { headline, members } = teamTranslations[currentLang];

  return (
    <TeamContainer>
      <Header>
        <Headline>{headline}</Headline>
      </Header>

      <TeamGrid>
        {members.map((member, index) => (
          <MemberCard key={index}>
            <NameSection>
              {currentLang === 'ko' ? (
                <>
                  <EnglishName>{member.koreanName}</EnglishName>
                  <LocalizedName>{member.name}</LocalizedName>
                </>
              ) : currentLang === 'zh' ? (
                <>
                  <EnglishName>{member.name}</EnglishName>
                  <LocalizedName>{member.chineseName}</LocalizedName>
                </>
              ) : currentLang === 'ja' ? (
                <>
                  <EnglishName>{member.name}</EnglishName>
                  <LocalizedName>{member.chineseName}</LocalizedName>
                </>
              ) : (
                <EnglishName>{member.name}</EnglishName>
              )}
            </NameSection>
            <Role>{member.role}</Role>
            {member.position && <Position>{member.position}</Position>}
            <Expertise>{member.expertise}</Expertise>
            {member.linkedin && (
              <LinkedInButton href={member.linkedin} target="_blank" rel="noopener noreferrer">
                LinkedIn
              </LinkedInButton>
            )}
          </MemberCard>
        ))}
      </TeamGrid>
    </TeamContainer>
  );
}

export default TeamTab;